$('#section-verification').on("submit", function (e) {
    e.preventDefault();

    //validate entire form
    if (!$(this).valid()) {
        return;
    }

    $(':submit', this).attr('disabled', 'disabled');
        
    $("*[id*=section-]:visible").hide();

    $("#section-loading").show();

    $.ajax({
        url: "/Application/VerifyID",
        type: "POST",
        data: $(this).serialize(),
        success: function (data) {
            $("button.gold").hide();
            $(".applybutton").show();


            switch (data.result) {
                case "NotVerified":
                    $("*[id*=section-]:visible").hide();
                    $("#section-verification").show();
                    return;
                case "VerifiedWithOffer":
                    $("*[id*=section-]:visible").hide();
                    $(".section-verification-text").hide();
                    $("#section-confirmation").show();
                    $("#successmessage").html("<h1><strong>You're pre-approved, " + data.name + '!</h1></strong> <br /><p style="margin-bottom:1rem;">We’ve found a credit card offer based on your information. You’re just a few steps away from completing your application.</p> <p style="margin-bottom:1rem;">If you choose to submit an application, a hard inquiry will be made on your credit report, which may impact your credit score. </p> <button type="button" role="tooltip" data-html="true" aria-labelledby="pre-approval-tooltip" class="preapprovepopover badge-white text-ultramarine border-0 strong pl-0 py-0 small mt-1 mb-2 line-height-120" data-container="body" data-toggle="popover" data-placement="top" data-content="Pre-approved means Merrick Bank has verified through consumer reporting agencies that you meet our prescreen credit criteria for this offer. <br/><br/><p>However, your application may still be declined if:</p><ul><li>You no longer meet the criteria at the time of application</li><li>Your income is insufficient to meet your obligations</li><li>We cannot verify your identity with the information provided</li><li>You do not have a verifiable U.S. physical home address</li><li>At the time of your application you fail to meet the criteria established for this offer</li></ul>" aria-label="Pre-approved means Merrick Bank has verified through consumer reporting agencies that you meet our prescreen credit criteria for this offer. <br/><br/><p>However, your application may still be declined if:</p><ul><li>You no longer meet the criteria at the time of application</li><li>Your income is insufficient to meet your obligations</li><li>We cannot verify your identity with the information provided</li><li>You do not have a verifiable U.S. physical home address</li><li>At the time of your application you fail to meet the criteria established for this offer</li></ul>"><small>What does pre-approved mean?</small></button>');

                    $('.preapprovepopover').popover({
                        container: '#successmessage',
                        trigger: 'focus'
                    })
                    return;
                case "VerifiedWithoutOffer":
                    window.location.replace("/Application/Offer-Not-Available");
                    return;
                default:
                    window.location.replace("/Application/Error?e=verify");
            }

            window.location = "/Application/Error?e=verify";
        },
        error: function (jqXHR, textStatus, errorThrown) {
            window.location = "/Application/Error?e=verify-" + encodeURIComponent(errorThrown);
        },
        timeout: 60000
    });
});